import * as React from "react";

const AccessMap : React.FC = () => {
    return (
        <div className={"access-map"}>
            <img src={"/images/accessmap.png"} style={{maxWidth: "100%"}} alt={"宮岡クリニックアクセスマップ:JR環状線/地下鉄中央線『弁天町』駅より徒歩10分"}/>
            <div className={"access"}>
                JR環状線/地下鉄中央線<br/>
                『弁天町』駅より徒歩10分
            </div>
            <div className={"access-navi"}>
                <a href={"https://goo.gl/maps/uLGBZRxcgv5u8cE2A"} target={"_blank"}>Google Map で確認</a>
            </div>
            <div className={"access-navi"}>
                <a href={"/access.html"}>交通の詳細を見る</a>
            </div>
        </div>
    );
}

export default AccessMap;
